import { render, staticRenderFns } from "./AllProjectsPage.vue?vue&type=template&id=6aa953a5&scoped=true"
import script from "./AllProjectsPage.vue?vue&type=script&lang=ts"
export * from "./AllProjectsPage.vue?vue&type=script&lang=ts"
import style0 from "./AllProjectsPage.vue?vue&type=style&index=0&id=6aa953a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa953a5",
  null
  
)

export default component.exports